import index from "./formSanalAsuulga.vue";
export default index;
